<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';

  interface Props {
    value?: string[];
    onevent?: (payload: { type: 'click'; data: { path: string } }) => void;
  }

  let { value = [], onevent }: Props = $props();

  const onClickReport = (path): void => {
    onevent?.({ type: 'click', data: { path } });
  };
</script>

<div class="npdb-report-list-type" data-cy="npdb-report-section">
  {#each value as path, index}
    <a
      class="list-i"
      href="/"
      data-cy={`report-${index}`}
      onclick={(e) => { e.preventDefault(); onClickReport(path); }}
    >
      <div class="icon">
        <Icon value="icon-file" />
      </div>
      <div class="text" data-cy="report-label">{path.split('/').pop()}</div>
    </a>
  {:else}
    <div class="empty" data-cy="empty-report">No Report Found</div>
  {/each}
</div>

<style>
  .npdb-report-list-type {
    width: 100%;
  }
  .list-i {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: var(--grey-dark);
    text-decoration: none;
    padding: 12px 16px;
  }
  .list-i:nth-child(odd) {
    background-color: var(--grey-bg);
  }
  .list-i .icon {
    margin-right: 8px;
    display: flex;
    align-items: center;
  }
</style>
